module.exports = __webpack_public_path__ + "static/media/achievement-placeholder.6d26fa11.svg";